module.exports = __webpack_public_path__ + "img/agro-consulting.e9083d90.png";